"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mountIsland_1 = require("../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var Lang_js_1 = require("../Lang.js");
var NAVY = '#1c1c3c';
var STRIPE_BLUE = '#635bff';
// What the Stripe-hosted Customer Portal provides — shown to reviewers
var PORTAL_SECTIONS = [
    {
        heading: 'Current subscription',
        description: 'Shows the active plan (TWI Premium or Seminar Leader TWI), billing amount, and next renewal date.',
        actions: ['Cancel subscription at end of billing period'],
    },
    {
        heading: 'Payment methods',
        description: 'Lists saved cards on the Stripe customer account.',
        actions: ['Add a new card', 'Remove an existing card', 'Set a card as default'],
    },
    {
        heading: 'Billing history',
        description: 'Full list of past invoices with amounts and dates.',
        actions: ['Download PDF invoice', 'View invoice detail'],
    },
];
var TwiPortalMockup = function () {
    var _a;
    var dataset = ((_a = document.getElementById('twi-portal-mockup')) === null || _a === void 0 ? void 0 : _a.dataset) || {};
    var isMockup = dataset.mockup === '1';
    return (react_1.default.createElement(Box_1.default, { sx: { p: 2, maxWidth: '720px', mx: 'auto', backgroundColor: '#f5f6f8' } },
        react_1.default.createElement(Typography_1.default, { component: "a", href: "/app/twi/subscriptions", sx: { display: 'block', mb: 1.5, fontSize: '14px', fontWeight: 600, color: NAVY, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } } },
            "\u2190 ",
            (0, Lang_js_1.__)('Back to Subscription')),
        isMockup && (react_1.default.createElement(Alert_1.default, { severity: "info", sx: { mt: 1.5, mb: 2.5, fontSize: '13px' } },
            react_1.default.createElement("strong", null, (0, Lang_js_1.__)('Mockup only.')),
            ' ',
            (0, Lang_js_1.__)('In production, this button triggers a server-side redirect to the Stripe-hosted Customer Portal. The user leaves the MSIA app and lands on a Stripe URL. No custom UI needs to be built for this page.'))),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: '20px 24px', mb: 2, borderRadius: 2,
                backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            } },
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 } },
                react_1.default.createElement(Box_1.default, { sx: {
                        width: '32px', height: '32px', borderRadius: '6px',
                        backgroundColor: STRIPE_BLUE,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    } },
                    react_1.default.createElement(Typography_1.default, { sx: { color: '#fff', fontSize: '14px', fontWeight: 800, lineHeight: 1 } }, "S")),
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '15px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('Stripe Customer Portal')),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#888' } }, (0, Lang_js_1.__)('Stripe-hosted · billing.stripe.com/…')))),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555', lineHeight: 1.6, mb: 2 } },
                (0, Lang_js_1.__)('When a subscriber clicks "Manage Subscription", the Laravel app calls'),
                ' ',
                react_1.default.createElement("code", { style: { fontSize: '13px', backgroundColor: '#f3f4f6', padding: '2px 6px', borderRadius: '4px' } }, "$authUser->billingPortalUrl(route('twi.subscriptions'))"),
                ' ',
                (0, Lang_js_1.__)('and redirects the browser to the URL Stripe returns. The subscriber manages their account on Stripe\'s servers, then is sent back to'),
                ' ',
                react_1.default.createElement("code", { style: { fontSize: '13px', backgroundColor: '#f3f4f6', padding: '2px 6px', borderRadius: '4px' } }, "/app/twi/subscriptions"),
                "."),
            react_1.default.createElement(Divider_1.default, { sx: { mb: 2 } }),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1.5 } }, (0, Lang_js_1.__)('What the portal provides')),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } }, PORTAL_SECTIONS.map(function (s) { return (react_1.default.createElement(Box_1.default, { key: s.heading, sx: {
                    p: '14px 16px', borderRadius: 1.5,
                    border: '1px solid #e8e8e8',
                    backgroundColor: '#fafafa',
                } },
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 700, color: NAVY, mb: 0.5 } }, s.heading),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', lineHeight: 1.5, mb: 1 } }, s.description),
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap', gap: 0.75 } }, s.actions.map(function (a) { return (react_1.default.createElement(Box_1.default, { key: a, sx: {
                        px: '10px', py: '3px', borderRadius: '12px',
                        backgroundColor: 'rgba(99,91,255,0.08)',
                        color: STRIPE_BLUE,
                        fontSize: '12px', fontWeight: 600,
                    } }, a)); })))); }))),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: '16px 20px', borderRadius: 2,
                backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            } },
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 } }, (0, Lang_js_1.__)('Portal configuration (step 10)')),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', lineHeight: 1.6 } }, (0, Lang_js_1.__)('The portal\'s allowed actions are configured in the Stripe Dashboard under Billing → Customer Portal settings — separately for sandbox (staging) and production. Actions not enabled there won\'t appear in the portal UI.')))));
};
var twiPortalMockupEl = document.getElementById('twi-portal-mockup');
if (twiPortalMockupEl) {
    (0, mountIsland_1.mountIsland)(twiPortalMockupEl, react_1.default.createElement(TwiPortalMockup, null));
}
exports.default = TwiPortalMockup;
